"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTextMask = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var createAutoCorrectedDatePipe_1 = tslib_1.__importDefault(require("text-mask-addons/dist/createAutoCorrectedDatePipe"));
var Base_1 = require("../Base");
var DATE_FORMAT = 'mm/dd/yyyy';
var DATE_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
exports.DateTextMask = function (_a) {
    var _b = _a.format, format = _b === void 0 ? DATE_FORMAT : _b, _c = _a.mask, mask = _c === void 0 ? DATE_MASK : _c, minYear = _a.minYear, maxYear = _a.maxYear, rest = tslib_1.__rest(_a, ["format", "mask", "minYear", "maxYear"]);
    var handlePipe = react_1.useMemo(function () { return createAutoCorrectedDatePipe_1.default(format, { minYear: minYear, maxYear: maxYear }); }, [format, minYear, maxYear]);
    return react_1.default.createElement(Base_1.TextMask, tslib_1.__assign({}, rest, { mask: mask, pipe: handlePipe, keepCharPositions: true }));
};
exports.DateTextMask.displayName = 'FOS_DateTextMask';
